// src/App.js
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import HomePage from './pages/HomePage';
import BarLoungeMenuPage from './pages/facilities/BarLoungeMenuPage';
import CocktailDetailPage from './pages/facilities/CocktailDetailPage';
import AvailabilityDashboardPage from './pages/facilities/AvailabilityDashboardPage';
import CleaningSchedulePage from './pages/facilities/CleaningSchedulePage';
import UsageAnalyticsDashboard from './components/analytics/UsageAnalyticsDashboard';
import { isFeatureEnabled } from './config/featureFlags';
import './App.css';

const CustomCocktailBuilderPage = lazy(() => import('./pages/facilities/CustomCocktailBuilderPage'));

function App() {
  return (
    <Router>
      <MainLayout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/facilities/bar-lounge" element={<BarLoungeMenuPage />} />
          <Route path="/facilities/bar-lounge/:cocktailName" element={<CocktailDetailPage />} />
          {isFeatureEnabled('customCocktails') && (
            <Route
              path="/facilities/bar-lounge/custom"
              element={(
                <Suspense fallback={<div className="page-loading">読み込み中…</div>}>
                  <CustomCocktailBuilderPage />
                </Suspense>
              )}
            />
          )}
          <Route path="/facilities/availability" element={<AvailabilityDashboardPage />} />
          <Route path="/cleaning-schedule" element={<CleaningSchedulePage />} />
          <Route path="/analytics" element={<UsageAnalyticsDashboard />} />
          {/*
          将来的に他のルートを追加する場合の例：
          <Route path="/announcements" element={<AnnouncementsPage />} />
          <Route path="/facilities/gym" element={<GymPage />} />
          */}
        </Routes>
      </MainLayout>
    </Router>
  );
}

export default App;
